// extracted by mini-css-extract-plugin
export default {"item":"JW74I","promo":"zMx0a","title":"fDoCg","fatty":"qmHZD","viewHybrid":"K19uk","icon":"A4B38","viewImage":"PC_B1","name":"BUehf","rounded":"vdo3n"};